import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=338fefd8&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338fefd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('338fefd8')) {
      api.createRecord('338fefd8', component.options)
    } else {
      api.reload('338fefd8', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=338fefd8&scoped=true&", function () {
      api.rerender('338fefd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/distributionArea/index.page.vue"
export default component.exports